export default "__VITE_ASSET__CnkjC4da__"